import { types } from "mobx-state-tree"

const MikaNationality = types.model('MikaNationality', {
    id: types.identifierNumber,
    name: types.string,
    code: types.string,
})

export default MikaNationality
